export class ProcedureInstructionModel {
    instruction: string;
    sessionExpiry: boolean;
    SessionTimeout: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/Procedure/Procedureinstructionmodel.ts